import { api } from 'shared';
import { z } from 'zod';

export const CompanyInformationResponseSchema = z.object({
    data: z.object({
        phone: z.string(),
        email: z.string(),
        yandexMapReviewLink: z.string(),
        logoImage: z.object({
            url: z.string(),
        }),
        mainImage: z.object({
            url: z.string(),
        }).optional().nullable(),
        address: z.object({
            name: z.string(),
            latitude: z.number(),
            longitude: z.number(),
        }).optional().nullable(),
        socialMedias: z.array(
            z.object({
                name: z.string(),
                image: z.object({
                    url: z.string(),
                }),
                link: z.string(),
                showMobile: z.boolean().optional().nullable(),
            }),
        ).optional().nullable(),
        contacts: z.array(
            z.object({
                title: z.string(),
                image: z.object({
                    url: z.string(),
                }).optional().nullable(),
                link: z.string().optional().nullable(),
            }),
        ).optional().nullable(),
        feedbackContacts: z.array(
            z.object({
                title: z.string(),
                image: z.object({
                    url: z.string(),
                }).optional().nullable(),
                link: z.string().optional().nullable(),
            }),
        ).optional().nullable(),
        background: z.object({
            url: z.string(),
        }).optional().nullable(),
        defaultDeliveryFIlter: z.string().optional().nullable(),
        seasonOffer: z.object({
            title: z.string(),
            link: z.string(),
        }).optional().nullable(),
    }),
});
export const fetchCompanyInformation = async () => (
    api.get<z.infer<typeof CompanyInformationResponseSchema>>(
        '/company-information',
        {
            populate: {
                address: {
                    fields: '*',
                },
                logoImage: {
                    fields: ['url'],
                },
                mainImage: {
                    fields: ['url'],
                },
                socialMedias: {
                    fields: '*',
                    populate: {
                        image: {
                            fields: ['url'],
                        },
                    },
                },
                contacts: {
                    fields: '*',
                    populate: {
                        image: {
                            fields: ['url'],
                        },
                    },
                },
                feedbackContacts: {
                    fields: '*',
                    populate: {
                        image: {
                            fields: ['url'],
                        },
                    },
                },
                seasonOffer: {
                    fields: '*',
                },
                background: {
                    fields: ['url'],
                },
            },
            fields: [
                'phone',
                'email',
                'defaultDeliveryFIlter',
                'yandexMapReviewLink',
            ],
        },
        CompanyInformationResponseSchema,
    )
);
